import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19 6.94H12.529C12.198 6.94 11.888 6.776 11.702 6.502L10.297 4.437C10.111 4.164 9.802 4 9.471 4H5C3.895 4 3 4.895 3 6V18C3 19.105 3.895 20 5 20H19C20.105 20 21 19.105 21 18V8.94C21 7.836 20.105 6.94 19 6.94Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.702 6.502L12.3225 6.08076L12.3221 6.0801L11.702 6.502ZM10.297 4.437L10.9171 4.0151L10.9168 4.01471L10.297 4.437ZM19 6.19H12.529V7.69H19V6.19ZM12.529 6.19C12.4462 6.19 12.3688 6.14887 12.3225 6.08076L11.0815 6.92324C11.4072 7.40313 11.9498 7.69 12.529 7.69V6.19ZM12.3221 6.0801L10.9171 4.0151L9.67692 4.8589L11.0819 6.9239L12.3221 6.0801ZM10.9168 4.01471C10.5915 3.53726 10.0508 3.25 9.471 3.25V4.75C9.55321 4.75 9.63048 4.79074 9.67719 4.85929L10.9168 4.01471ZM9.471 3.25H5V4.75H9.471V3.25ZM5 3.25C3.48079 3.25 2.25 4.48079 2.25 6H3.75C3.75 5.30921 4.30921 4.75 5 4.75V3.25ZM2.25 6V18H3.75V6H2.25ZM2.25 18C2.25 19.5192 3.48079 20.75 5 20.75V19.25C4.30921 19.25 3.75 18.6908 3.75 18H2.25ZM5 20.75H19V19.25H5V20.75ZM19 20.75C20.5192 20.75 21.75 19.5192 21.75 18H20.25C20.25 18.6908 19.6908 19.25 19 19.25V20.75ZM21.75 18V8.94H20.25V18H21.75ZM21.75 8.94C21.75 7.42203 20.5195 6.19 19 6.19V7.69C19.6905 7.69 20.25 8.24997 20.25 8.94H21.75Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgFolderFilled);
export default ForwardRef;
